import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { BrandPreviewQuery, BrandPreviewQueryVariables } from 'types/graphql'
import { reviewSummaryFragment } from 'modules/reviews/fragments.graphql'

const brandPreviewQuery = gql`
  query BrandPreview($slug: String!) {
    brand(slug: $slug) {
      id
      title
      slug
      rip
      primaryImageFullPath
      primaryImageProminentColorHex
      description
      myReview {
        id
      }
      reviewSummary {
        ...ReviewSummaryFields
      }
    }
  }
  ${reviewSummaryFragment}
`

export const useLazyBrandPreview = () => {
  return useLazyQuery<BrandPreviewQuery, BrandPreviewQueryVariables>(brandPreviewQuery)
}

export const useBrandPreview = ({ variables }: { variables: BrandPreviewQueryVariables }) => {
  return useQuery<BrandPreviewQuery, BrandPreviewQueryVariables>(brandPreviewQuery, { variables })
}
